<template>
  
  <v-dialog content-class="v-dialog-movable" v-model="show_message" persistent :max-width="dialog_type == 'absolute' ? '1000' : '800'">    
    <v-card>
      <v-card-title class="headline mb-8">
        <div>Editar Contrapartidas</div>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="6" class="text-center table-head row-head primary--text" v-if="dialog_type == 'absolute'">
              Concepto
          </v-col>
          <v-col :cols="dialog_type == 'absolute' ? '2' : '3'" class="text-center table-head row-head primary--text">
            <template v-if="dialog_type == 'absolute'">Importe</template>
            <template v-else>Cantidad</template>
          </v-col>
          <v-col v-if="dialog_type == 'percentage'" cols="2" class="text-center table-head row-head primary--text">
            % o Fijo
          </v-col>
          <v-col :cols="dialog_type == 'absolute' ? '3' : '5'" class="text-center table-head row-head primary--text">
            <v-row no-gutters>
              <v-col :cols="got_feature('feature_project_bank_counterpart') ? '6' : '12'">Contrapartida</v-col>
              <v-col v-if="got_feature('feature_project_bank_counterpart')" :cols="6">{{ analytic_label }}</v-col>
            </v-row>
          </v-col>
          <v-col cols="1" v-if="!readonly" class="text-center table-head row-head primary--text">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  v-bind="attrs" 
                  v-on="on"
                  @click="add()"
                  tile
                  color="primary"
                  width="100%"
                  min-width="auto">
                  <v-icon >mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Añadir línea</span>
            </v-tooltip>
          </v-col>
        </v-row>
       
        <v-row v-for="(linea, i) in mCounterparts" :key="i" no-gutters>
          <v-col cols="6" class="table-row" v-if="dialog_type == 'absolute'">
              <v-text-field
                :readonly="readonly"    
                v-model="linea.concept"
                :key="'line_concept_' + i"
                hide-details
                single-line
                solo
                flat
                dense
                class="pa-0 mx-2 input__component"
              ></v-text-field>                   
            </v-col>
            <v-col :cols="dialog_type == 'absolute' ? '2' : '3'" class="table-row">
              <v-text-field
                kind="number"
                :readonly="readonly"    
                v-model="linea.amount"
                :key="'line_percentage_' + i"
                hide-details
                @input="validateInput(linea, $event)"
                @change="fixNumber(linea)"  
                class="align__right pa-0 ma-0 input__component"
                dense
                solo
                flat
              ></v-text-field>
            </v-col>

            <v-col cols="2" class="table-row align-center" v-if="dialog_type == 'percentage'">
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs">
                      <div class="btn-switch_counterpart mx-auto mt-2"
                        v-on:click="(linea.hasOwnProperty('amount_type') && linea.amount_type=='fixed') ? mCounterparts[i].amount_type = 'percentage' : mCounterparts[i].amount_type = 'fixed'; check_amount()"
                        >
                        <div v-if="!linea.hasOwnProperty('amount_type') || (linea.hasOwnProperty('amount_type') && linea.amount_type == 'percentage')" class="pa-0 ma-0 d-flex mr-1">
                          <AppIcon :src="require('../assets/bank-account-switch.svg')" :size="29" :preserve-colors="true" />                      
                        </div>

                        <span class="text__switch primary--text">{{ linea.hasOwnProperty('amount_type') && linea.amount_type=='fixed' ? 'Fj':'%' }} </span>

                        <div v-if="linea.hasOwnProperty('amount_type') && linea.amount_type =='fixed'" class="pa-0 ma-0 d-flex ml-1">
                          <AppIcon :src="require('../assets/bank-effect-switch.svg')" :size="29" :preserve-colors="true" />                        
                        </div>
                      </div>
                    </div>
                  </template>
                  <span v-if="linea.hasOwnProperty('amount_type') && linea.amount_type =='fixed'">Fijo</span>
                  <span v-else>Porcentaje</span>
                </v-tooltip>
            </v-col>

            <v-col :cols="dialog_type == 'absolute' ? '3' : '5'" class="table-row">
            <v-row no-gutters>
              <v-col :cols="got_feature('feature_project_bank_counterpart') ? '6' : '12'">
                <div class="d-flex mr-2" v-if="got_feature('feature_can_use_payable_or_receivable_effects') && work_with_effects && dialog_type != 'percentage'">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs">
                        <v-btn class="swicth_counterpart mr-1"
                        v-on:click="linea.kind=='account'? linea.kind='effect': linea.kind='account'; linea.account = ''"
                        :disabled="readonly"
                        >

                        <div v-if="linea.kind == 'account'" class="pa-0 ma-0 d-flex mr-1">
                          <AppIcon :src="require('../assets/bank-account-switch.svg')" :size="29" v-if="!readonly" :preserve-colors="true" />
                          <AppIcon :src="require('../assets/bank-account-switch-disabled.svg')" :size="29" v-else :preserve-colors="true" />
                        </div>

                        <span class="text__switch" :class="!readonly? 'primary--text': 'text_readonly'">{{ linea.kind=='account'? 'C':'F' }} </span>

                        <div v-if="linea.kind == 'effect'" class="pa-0 ma-0 d-flex ml-1">
                          <AppIcon :src="require('../assets/bank-effect-switch.svg')" :size="29" v-if="!readonly" :preserve-colors="true" />
                          <AppIcon :src="require('../assets/bank-effect-switch-disabled.svg')" :size="29" v-else :preserve-colors="true" />
                        </div>
                      </v-btn>
                      </div>
                    </template>
                    <span v-if="linea.kind=='account'">Cuenta</span>
                    <span v-else>Efecto</span>
                  </v-tooltip>
                  <ContrapartidaField
                    v-if="linea.kind == 'account'"
                    :readonly="readonly"
                    v-model="linea.account"
                    :items="accounts"
                    @get-values="getValues"
                    @reset-items="resetItems"
                    :num_digits="num_digits"
                    right_input
                  ></ContrapartidaField>
                  <v-combobox
                    v-else
                    :readonly="readonly"
                    :items="filteredEffectsCounterpart"
                    :item-value="item => item.account + '-' + item.code"
                    item-text="account"
                    v-model="linea.account"
                    class="align__right__no_padding input__component"
                    :append-icon="null"
                    :hide-details="true"
                    @change="changeEffect()"
                    @input.native="myNativeInputEffectCounterpart($event, object_amount)"
                    @click="myNativeInputEffectCounterpart($event, object_amount)"
                    @blur="resetEffectsCounterpartItems"
                    return-object
                    no-filter
                    solo
                    flat
                    dense
                    >
                    <template v-slot:item="data">
                      {{ `${data.item.account} - (${data.item.amount}€) - (${data.item.date}) - (${data.item.code}) - ${data.item.concept}`}}
                    </template>
                  </v-combobox>
                </div>
                <div v-else>
                  <ContrapartidaField
                    :readonly="readonly"
                    v-model="linea.account"
                    :items="accounts"
                    @get-values="getValues"
                    @reset-items="resetItems"
                    :num_digits="num_digits"
                    right_input
                  ></ContrapartidaField>
                </div>
              </v-col>
              <v-col v-if="got_feature('feature_project_bank_counterpart') && accountIsGroup6or7(linea) && analytic_attr_name" :cols="6">
                <v-autocomplete class="ml-2"
                  :clearable="true"
                  :items="company_analytic_entities"
                  v-model="linea[analytic_attr_name]"
                  item-text="name"
                  item-value="id"
                  :background-color="'#ffffff'"
                  dense
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            </v-col>
          
            <v-col cols="1" v-if="!readonly" class="table-row text-center">
              <v-btn @click="remove(i)"
                color="primary"
                icon
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-col>    
        </v-row>
        <div v-if="amount_error" class="red--text">{{ error_text }}</div>
      </v-card-text>
      <v-card-actions class="pa-6">
        <v-btn color="primary" rounded outlined text class="primary-border px-4" @click="closeDialog()">Cerrar</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!readonly" rounded :disabled="amount_error" color="primary" class="primary-border px-4" @click="saveDialog()">Confirmar</v-btn>                
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MetadataField from './MetadataField.vue'
import ContrapartidaField from "./layout/ContrapartidaField.vue";
import {evaluate} from 'mathjs'
import {round} from '../utils'
import Vue from 'vue'

export default {
  name: 'DialogBankCounterpart',
  components:{
      MetadataField,
      ContrapartidaField,
  },
  props: {   
    show_message: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    object_amount: {
      type: Number,
      required: true
    },
    dialog_type: {
      type: String,      
      default: "absolute" //"percentage", "absolute"
    },
    default_concept: {
      type: String,
      default: ""
    },
    object_id: {
      type: String | Number,
      required: true
    },
    counterparts:  {
      type: Array,
      default: [],    
    },
    effects:{
      type: Array,
      default: () => []
    },
    company_id: {
      type: [Number, String],
      required: true
    },
    num_digits: {
      type: Number,
      required: true
    },
    work_with_effects: {
      type: Boolean,
      default: false
    },
    company_analytic_entities: {
      type: Array,
      default: () => []
    },
    analytic_attr_name: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      mCounterparts: [],
      amount_error: false,
      error_text: '',
      effect_list: [],
      accounts: [],
      filteredEffectsCounterpart: [],
      analytic_label: "",
    }
  },
  computed:{
    ...mapGetters({
      got_feature:'got_feature',
      permission: 'permissions/permission',
    }),
    that(){
      return this
    },
  },
  methods:{    
    ...mapActions("cru", ['getAccounts2']),    

    async getValues(params) {
      params['companydb_id'] = this.company_id
      let items = await this.getAccounts2(params);
      this.accounts = items;
    },
    resetItems(params) {
      this.accounts = params;
    },    
    closeDialog(){            
      this.$emit("close-dialog");
    },
    saveDialog(){
      this.fix_counterparts_analytics() // ensure no counterpart with account group 6 or 7 has analytics
      this.$emit("save-dialog", {"counterparts": this.mCounterparts, "object_id": this.object_id});
    },
    add(){
      let line = undefined
      if (this.dialog_type == 'absolute'){
        line = {'amount': (this.mCounterparts.length == 0) ? this.object_amount: '', 'account': '', 'concept': this.default_concept, 'kind': 'account'}
        if (this.analytic_attr_name) {
          line[this.analytic_attr_name] = undefined
        }
      }
      else { // Rules counterpart doesn't have concept/analytic attribute
        line = {'amount': (this.mCounterparts.length == 0) ? this.object_amount: '', 'account': '', 'kind': 'account', 'amount_type': 'percentage'}  
      }
      this.mCounterparts.push(line);
      this.check_amount();
    },
    remove(pos){
      this.mCounterparts.splice(pos,1);
      this.check_amount()
    },
     fix_counterparts_analytics() { // for each counterpart, if account group is not 6 or 7, set analytics to undefined
      if (!this.analytic_attr_name) return
      for (let i in this.mCounterparts) {
        if (!this.accountIsGroup6or7(this.mCounterparts[i])) {
          this.mCounterparts[i][this.analytic_attr_name] = undefined
        }
      }
    },
    check_amount(){
      this.error_text = '';
      this.amount_error = false;
      
      // Validar que no haya importes vacíos
      for (let i in this.mCounterparts) {
        const amount = this.mCounterparts[i].amount;
        // Verificar si está vacío o es null/undefined, pero permitir 0
        if (amount === '' || amount === null || amount === undefined) {
          this.error_text = "No puede dejar casillas de importe vacías";
          this.amount_error = true;
          return;
        }
      }
      
      let total_amount = null;      
      if (!isNaN(this.object_amount)){
        total_amount = parseFloat(this.object_amount)
      }
      else if (typeof this.object_amount == 'string') {
        try {
          total_amount = parseFloat(this.object_amount.replace(/[a-z]/gi, '').replace(',','.'))
        }
        catch (error) {
          console.log(error)
          return;
        }
      }      
      else {
        return;
      }
      
      // Validar que total_amount sea un número válido
      if (isNaN(total_amount)) {
        this.error_text = "El importe total de la transacción no es válido";
        this.amount_error = true;
        return;
      }
      
      let calculated_amount = 0.0      
      for (let i in this.mCounterparts) {
        if ((this.mCounterparts[i].amount !== '' && this.mCounterparts[i].amount !== null && this.mCounterparts[i].amount !== undefined)){          
          try {
            if (this.dialog_type == 'absolute' || this.mCounterparts[i].amount_type == 'percentage') {
              let parsed_amount = parseFloat(this.mCounterparts[i].amount.toString().toLowerCase().replace(/,/g,'.').replace('€','').replace('$','').replace('eur',''));
              if (isNaN(parsed_amount)) {
                this.error_text = "Uno o más importes no son válidos";
                this.amount_error = true;
                return;
              }
              calculated_amount += parsed_amount;
            }
          }
          catch {
            continue;
          }                      
        }
        else if (typeof this.mCounterparts[i] == 'string') {
          try {
            if (this.dialog_type == 'absolute' || this.mCounterparts[i].amount_type == 'percentage') {
              let parsed_amount = parseFloat(this.mCounterparts[i].replace(/[a-z]/gi, '').replace(',','.'));
              if (isNaN(parsed_amount)) {
                this.error_text = "Uno o más importes no son válidos";
                this.amount_error = true;
                return;
              }
              calculated_amount += parsed_amount;
            }
          }
          catch (error) {
            console.log(error)
            break;
          }
        }      
        else {
          continue;
        }
      }
      calculated_amount = round(calculated_amount, 2);
      if (this.dialog_type == 'absolute' && (calculated_amount + total_amount) != 0) {      
        this.error_text = "El importe de las contrapartidas difiere del total de la transacción: " + (total_amount + calculated_amount).toFixed(2);
        this.amount_error = true
      }
      else if (this.dialog_type == 'percentage' && (calculated_amount - total_amount) != 0) {      
        this.error_text = "El porcentaje de las contrapartidas debe sumar 100%: " + (total_amount - calculated_amount).toFixed(0);
        this.amount_error = true
      }      
    },
    fixNumber(linea) {
      var ev=linea.amount.toString().toLowerCase().replace(/,/g,'.').replace('€','').replace('$','').replace(/[a-z]/gi, '');
      try {
        var newValue=round(evaluate(ev),2)
      }
      catch(err) {
        var newValue=ev;
      }
      
      // Validar que el resultado sea un número válido (incluyendo 0)
      if(newValue !== '' && newValue !== null && newValue !== undefined && !isNaN(parseFloat(newValue)) && isFinite(newValue)){
        linea.amount = newValue;
      } else {
        // Si no es un número válido, vaciar el campo
        linea.amount = '';
      }
      this.check_amount();
    },
    validateInput(linea, value) {
      // Permitir solo números, puntos, comas, signos negativos y símbolos de moneda
      const cleanValue = value.toString().toLowerCase().replace(/,/g,'.').replace('€','').replace('$','').replace('eur','');
      
      // Verificar si después de limpiar, queda algo que pueda ser un número
      // Permitimos números, puntos, comas, y el signo menos
      const validPattern = /^-?[\d.,]*$/;
      
      if (!validPattern.test(cleanValue)) {
        // Si contiene letras u otros caracteres no válidos, eliminarlos
        const sanitized = cleanValue.replace(/[^\d.,-]/g, '');
        linea.amount = sanitized;
      }
      
      this.check_amount();
    },
    changeEffect() {
      for (var i in this.mCounterparts) {
        let tmp = this.mCounterparts[i].account
        if (typeof(tmp) === 'object') {
            if (tmp.effect_type == 'receivable_effect') {
              tmp.amount = -tmp.amount;
            }
            this.mCounterparts[i] = tmp
        }
      }
      this.effect_list = structuredClone(this.effects);
      this.check_amount();
    },
    getEffectsCounterpartValues(amount, text) {
      this.filteredEffectsCounterpart = this.filteredEffectsByAmountAndText(amount, text)      
    },
    myNativeInputEffectCounterpart(event,amount) {
      console.log("myNativeInputEffectCounterpart: " + amount + " --- value: " + event.target.value)      
      this.getEffectsCounterpartValues(amount, event.target.value)
    },
    resetEffectsCounterpartItems(params){
      
    },
    filteredEffectsByAmountAndText(amount, text) {
      if (text) {
        return this.effect_list.filter((x) => Math.abs(x.amount) <= Math.abs(amount) && x.concept.toLowerCase().includes(text.toLowerCase()));
      } else {
        return this.effect_list.filter((x) => Math.abs(x.amount) <= Math.abs(amount));
      }
    },
    accountIsGroup6or7(counterpart) {
      const account_str = counterpart.account.toString()
      return account_str.startsWith('6') || account_str.startsWith('7')
    },
    loadCounterparts() {
      this.mCounterparts = JSON.parse(JSON.stringify(this.counterparts))
      if (this.dialog_type == 'absolute') {
        for (let c in this.mCounterparts) {
          if (!this.mCounterparts[c].hasOwnProperty('concept') || this.mCounterparts[c].concept == null) {
            this.mCounterparts[c].concept = this.default_concept
          }
          if (this.analytic_attr_name && !this.mCounterparts[c].hasOwnProperty(this.analytic_attr_name)) {
            this.mCounterparts[c][this.analytic_attr_name] = undefined
          }
        }
      }
      else { // Percentage - rules        
        for (let i in this.mCounterparts) {
          if (!this.mCounterparts[i].hasOwnProperty('amount_type')) {
            Vue.set(this.mCounterparts[i], 'amount_type', 'percentage') // Lo metemos asi si no no tenemos reactividad
          }
        }
      }
    },
  },
  created() {
    if (Array.isArray(this.company_analytic_entities) && this.company_analytic_entities.length > 0) {
      switch (this.analytic_attr_name) {
        case 'department':
          this.analytic_label = "Departamento"
          break
        case 'project':
          this.analytic_label = "Proyecto"
          break
        default:
          this.analytic_label = ""
          break
      }
    }
    if (Array.isArray(this.counterparts)) {
      this.loadCounterparts();
      this.check_amount();
    } else {
      this.mCounterparts = [];
    }
    
    (function () { // make vuetify dialogs movable
        const d = {};
        document.addEventListener("mousedown", e => {
            const closestDialog = e.target.closest(".v-dialog-movable.v-dialog--active");
            if (e.button === 0 && closestDialog != null && e.target.classList.contains("v-card__title")) { // element which can be used to move element
                d.el = closestDialog; // element which should be moved
                d.mouseStartX = e.clientX;
                d.mouseStartY = e.clientY;
                d.elStartX = d.el.getBoundingClientRect().left;
                d.elStartY = d.el.getBoundingClientRect().top;
                d.el.style.position = "fixed";
                d.el.style.margin = 0;
                d.oldTransition = d.el.style.transition;
                d.el.style.transition = "none"
            }
        });
        document.addEventListener("mousemove", e => {
            if (d.el === undefined) return;
            d.el.style.left = Math.min(
                Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
                window.innerWidth - d.el.getBoundingClientRect().width
            ) + "px";
            d.el.style.top = Math.min(
                Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
                window.innerHeight - d.el.getBoundingClientRect().height
            ) + "px";
        });
        document.addEventListener("mouseup", () => {
            if (d.el === undefined) return;
            d.el.style.transition = d.oldTransition;
            d.el = undefined
        });
        setInterval(() => { // prevent out of bounds
            const dialog = document.querySelector(".v-dialog-movable.v-dialog--active");
            if (dialog === null) return;
            dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + "px";
            dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + "px";
        }, 100);
    })();    
  },
  watch: {
    show_message: function(newVal, oldVal) {      
      if (Array.isArray(this.counterparts)) {
        this.loadCounterparts();
      } else {
        this.mCounterparts = [];
      }
      this.check_amount();    
    }    
  },
  mounted() {
    if (this.got_feature('feature_can_use_payable_or_receivable_effects')) {
      this.effect_list = structuredClone(this.effects);
    }
  }
}

</script>

<style scoped>
    .v-dialog-movable .v-card__title {
      cursor: move; /* fallback if grab cursor is unsupported */
      cursor: grab;
      cursor: -moz-grab;
      cursor: -webkit-grab;
      border-bottom: 1px solid #e6e6e6;
    }
    .v-dialog-movable .v-card__title:active {
      cursor: grabbing;
      cursor: -moz-grabbing;
      cursor: -webkit-grabbing;
    }
    .v-dialog-movable .v-card__title div,
    .v-dialog-movable .v-card__title div:active {
      cursor: default;
    }
    .v-dialog-movable .v-card__actions .v-btn{
      text-transform: capitalize;
    }
    .table-head{
      border-left-style:solid;
      border-right-style:solid;
      border-bottom-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .row-head {
      border-top-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
      line-height: 32px;
      font-weight: bold;
    }
    .table-row{
      border-left-style:solid;
      border-right-style:solid;
      border-bottom-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .table-row >>> div > .row > .col > div > .v-text-field {
      margin-top: 0px;
    }
    .table-row >>> div > .v-text-field {
      margin-top: 0px;
    }
    .table-row >>> div > .row > .col > div > .v-text-field > .v-input__control > .v-input__slot {
      height: 36px;
    }
    .table-row >>> div > .v-text-field > .v-input__control > .v-input__slot {
      height: 36px;
    }
    .table-button {
        border-bottom-style:solid;
        border-width: thin;
        border-bottom-color: rgba(0,0,0,.42);
        margin-bottom: -1px;
    }
    .v-dialog-movable .table-row >>> input {
      font-size:14px !important;
    }

  .align__right >>> input {
    text-align: right !important;
    padding-right: 8px !important;
  }
  .align__right__no_padding >>> input {
    text-align: right !important;
    padding-right: 0px !important;
  }
  .v-text-field {
    padding-top:0px;
  }

  .input__component >>> .v-input__control>.v-input__slot {
    padding: 0px !important;
  }

  .swicth_counterpart {
    border: 1px solid #DFDFDF;
    border-radius: 0px !important;
    background-color: transparent !important;
    box-shadow: none !important;
    text-transform: none !important;
    width: 50%;
    height: 100% !important;
  }

  .swicth_counterpart .v-btn__content {
    display: flex !important;
    align-items: center !important;
  }

  .swicth_counterpart.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: transparent !important;
  }

  .btn-switch_counterpart {
    border-radius: 14px;
    border: 1px solid #DFDFDF;    
    box-shadow: none !important;
    height: 24px !important;
    width: 40px !important;
    text-transform: none !important;
    display:flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
  }
  
  .text_readonly {
    color: #CCCBCB;
  }
</style>
<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
</style>
